import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "messages-container"
}
const _hoisted_2 = { class: "userMessage" }
const _hoisted_3 = ["onClick"]

import IconMediumAlertWarning from '@/design-system/assets/icons/IconMediumAlertWarning.vue'
import IconX from '../assets/icons/IconX.vue'
import { useUserMessage } from '@/pinia/userMessage'
import { onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { UserMessage } from '@/interfaces/userMessage.interface'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMessage',
  setup(__props) {

const userMessageStore = useUserMessage()
const { isUserMessageActive, messages } = storeToRefs(userMessageStore)
const { fetchUserMessage, closeMessage } = userMessageStore
const { locale } = useI18n()
const isLoading = ref(false)

function getMessage(msg: UserMessage): string {
  const lang = locale.value || 'en'
  return msg.message[lang] || msg.message['en']
}

onMounted(async () => {
  isLoading.value = true
  fetchUserMessage()
})

return (_ctx: any,_cache: any) => {
  return (_unref(isUserMessageActive))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (msg, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "message-wrapper"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(IconMediumAlertWarning, { class: "warningIcon" }),
              _createTextVNode(" " + _toDisplayString(getMessage(msg) || ''), 1)
            ]),
            _createElementVNode("button", {
              class: "close-button",
              onClick: ($event: any) => (_unref(closeMessage)(msg))
            }, [
              _createVNode(IconX, { class: "closeIcon" })
            ], 8, _hoisted_3)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})